import React, { useEffect, Suspense } from "react";
const SignupIdScreen = React.lazy(() => import("./screens/SignupId"));
import { getCurrentScreen } from "@auth0/auth0-acul-js";
import ResetPasswordRequestScreen from "./screens/ResetPassword/ResetPasswordRequest.tsx";
import ResetPasswordScreen from "./screens/ResetPassword/ResetPassword.tsx";

const LoginIdScreen = React.lazy(() => import("./screens/LoginId"));


const App: React.FC = () => {
  const [screen, setScreen] = React.useState("login-id");
  useEffect(() => {
    const current = getCurrentScreen();
    setScreen(current!);
  }, []);

  const renderScreen = () => {
    switch (screen) {
      case "login-id":
        return <LoginIdScreen />;
      case "signup-id":
        return <SignupIdScreen/>;
      case "reset-password-request":
        return <ResetPasswordRequestScreen/>;
      case "reset-password":
        return <ResetPasswordScreen/>;
      default:
        return <>No screen rendered</>;
    }
  };
  console.log(`screen: ${screen} test`)
  return <Suspense fallback={<div>Loading...</div>}>{renderScreen()}</Suspense>;
};

export default App;
